import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { PublishedGroupShipments } from '@uturn/portal/modules/shipments';
import {
	GroupedShipmentsSearchSchema,
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const PublishedGroupedShipmentsSearchSchema =
	GroupedShipmentsSearchSchema.extend({
		'filter.statuses': fallback(
			ShipmentsSearchStatusesSchema.array(),
			SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED,
		).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED),
	});

export const Route = createFileRoute('/_protected/shipments/groups/$groupId/')({
	component: PublishedGroupShipments,
	validateSearch: zodValidator(PublishedGroupedShipmentsSearchSchema),
});
